import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  selectNotSendReason = (e) => {
    let sendButton = e.target.closest('form').querySelector('input[type="submit"]')
    sendButton.classList.toggle('hidden');
  }
}
